module.exports = __webpack_public_path__ + "img/0.d71b3aed.jpg";